import { useQuery } from "@tanstack/react-query";
import { getCompany } from "api/company.api";
import { QUERY_KEYS } from "config/queryKeys";

export const useGetCompany = () => {
  return useQuery({
    queryKey: QUERY_KEYS.company.detail(),
    queryFn: getCompany,
    select: (data) => data?.company ?? null,
    staleTime: 1000 * 60 * 5,
    retry: false,
  });
};
